(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-video-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root = document) => {
      root.querySelectorAll('.custom-video-hero').forEach((hero) => {
        const videos = [...hero.querySelectorAll('video')];
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const mobile = window.matchMedia('(max-width: 749px)').matches;

        videos.forEach((video) => {
          const isMobileVideo = video.classList.contains('custom-video-hero__video--mobile');
          const hasMobileVideo = hero.querySelector('.custom-video-hero__video--mobile');
          const isActive = hasMobileVideo ? isMobileVideo === mobile : !isMobileVideo;

          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;

          if (reduceMotion || !isActive) {
            video.pause();
            video.classList.remove('is-playing');
            return;
          }

          video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
          video.addEventListener('error', () => video.classList.remove('is-playing'));
          const playAttempt = video.play();
          if (playAttempt) playAttempt.catch(() => video.classList.remove('is-playing'));
        });
      });
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
